import { useState } from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { colors } from "styles/global-styles";
import { ReactComponent as BoardIcon } from "../../assets/image/sidemenu/icon_board.svg";
import { ReactComponent as BreadIcon } from "../../assets/image/sidemenu/icon_bread.svg";
import { ReactComponent as BusIcon } from "../../assets/image/sidemenu/icon_bus.svg";
import { ReactComponent as CalendarIcon } from "../../assets/image/sidemenu/icon_calendar.svg";
import { ReactComponent as HomeIcon } from "../../assets/image/sidemenu/icon_home.svg";
import { ReactComponent as ListIcon } from "../../assets/image/sidemenu/icon_list.svg";
import { ReactComponent as MedicineIcon } from "../../assets/image/sidemenu/icon_medicine.svg";
import { ReactComponent as MoneyIcon } from "../../assets/image/sidemenu/icon_money.svg";
import { ReactComponent as NoteIcon } from "../../assets/image/sidemenu/icon_note.svg";
import { ReactComponent as NoticeIcon } from "../../assets/image/sidemenu/icon_notice.svg";
import { ReactComponent as SettingIcon } from "../../assets/image/sidemenu/icon_setting.svg";
import { ReactComponent as PhotoIcon } from "../../assets/image/sidemenu/icon_photo.svg";
import { ReactComponent as TemperatureIcon } from "../../assets/image/sidemenu/icon_temperature.svg";

// Style button
// 버튼
const Btn = styled.button`
  padding: 0.625rem 1.25rem;
  border-radius: 0.5rem;
  &.contain-icon {
    display: flex;
    gap: 0.25rem 0.5rem;
    align-items: center;
  }
  &.little-btn {
    padding: 0.625rem 0.8rem;
    font-size: 0.75rem;
  }
  &:disabled {
    cursor: default;
    background-color: ${colors.lightGray};
    color: ${colors.gray};
    border: 1px solid ${colors.lightGray};
    &:hover {
      background-color: ${colors.lightGray};
      border: 1px solid ${colors.lightGray};
    }
  }
`;
// #1DC487
export const SolidPrimaryBtn = styled(Btn)`
  background-color: ${({theme}) => theme.newTheme.default.primary};
  border: 1px solid ${({theme}) => theme.newTheme.default.primary};
  color: ${({theme}) => theme.newTheme.text.btnText_w};
  &:hover {
    background-color: ${colors.primaryHover};
    border-color: ${colors.primaryHover};
  }
`;
// #E8F7F2
export const SolidPrimarySubBtn = styled(Btn)`
  background-color: ${({ theme }) => theme.newTheme.default.secondary};
  border: 1px solid ${({ theme }) => theme.newTheme.default.secondary};
  color: ${({theme}) => theme.newTheme.default.accent};
  &:hover {
    background-color: ${colors.secondaryHover};
    border-color: ${colors.secondaryHover};
  }
`;
// #ffffff
export const SolidPrimaryWhiteBtn = styled(Btn)`
  background-color: ${colors.white};
  border: 1px solid ${colors.white};
  color: ${colors.accent};
  &:hover {
    background-color: ${colors.secondaryHover};
  }
`;
// #F5E4E6
export const SolidRedBtn = styled(Btn)`
  background-color: ${colors.deleteBg};
  border: 1px solid ${colors.deleteBg};
  color: ${colors.red};
  &:hover {
    background-color: ${colors.deleteHover};
    border-color: ${colors.deleteHover};
  }
`;
// 테두리 #DEDEDE
export const OutlinePrimaryBtn = styled(Btn)`
  background-color: ${({ theme }) => theme.rootWhite};
  border: 1px solid ${({theme}) => theme.newTheme.border.primaryBd};
  color: ${({theme}) => theme.newTheme.text.btnOutlineText};
  &:hover {
    background-color: ${colors.lightGray};
  }
`;
// 테두리 #E0062D
export const OutlineRedBtn = styled(Btn)`
  background-color: ${colors.white};
  border: 1px solid ${colors.red};
  color: ${colors.red};
  &:hover {
    background-color: ${colors.deleteBg};
    border: 1px solid ${({theme}) => theme.newTheme.border.redBd};
    color: ${({theme}) => theme.newTheme.border.redBd};
  }
`;
export const NoLinePrimaryBtn = styled(Btn)`
  border: none;
  background-color: ${colors.white};
  color: ${({theme}) => theme.newTheme.text.btnOutlineText};
  &:hover {
    color: ${colors.primary};
  }
`
export const NoLineRedBtn = styled(Btn)`
  border: none;
  background-color: ${colors.white};
  color: ${colors.red};
  &:hover {
    color: ${({theme}) => theme.newTheme.border.redBd};
  }
`
// 읽음/읽지않음 모양
export const RoundText = styled.p<{ "data-is-read"?: boolean }>`
  background-color: ${(prop) =>
    prop["data-is-read"] ? colors.secondary : colors.lightYellow};
  color: ${(prop) =>
    prop["data-is-read"] ? colors.accent : colors.orange};
  padding: 0.25rem 0.75rem;
  border-radius: 1rem;
`;
// 공지사항 및 알림장 - 등록된 문서(File) 보여주는 div
export const AttachFileWrap = styled.div`
  padding: 0.75rem;
  border-radius: 0.5rem;
  background-color: ${colors.lightGray};
  > div {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }
  svg {
    &.pdf path {
      fill: #ff3838;
    }
    &.pptx path {
      fill: #ff6348;
    }
    &.docx path {
      fill: #3742fa;
    }
    &.xlsx path {
      fill: #26de81;
    }
  }
  .delete-doc,
  .save-doc {
    display: flex;
    visibility: hidden;
    margin-left: auto;
  }
  &:hover {
    cursor: pointer;
    .delete-doc,
    .save-doc {
      visibility: visible;
    }
  }
`;
// 검색 필터 초기화
export const ResetButton = styled.div``;

// sidemenu ----------------------------------------------------
// icon명에 따른 svg 추가 - 클릭 시 색상 변경때문에
const ReturnIconComponent = (name: string) => {
  switch (name) {
    case "Board":
      return <BoardIcon />;
    case "Bread":
      return <BreadIcon />;
    case "Bus":
      return <BusIcon />;
    case "Calendar":
      return <CalendarIcon />;
    case "Home":
      return <HomeIcon />;
    case "List":
      return <ListIcon />;
    case "Medicine":
      return <MedicineIcon />;
    case "Money":
      return <MoneyIcon />;
    case "Note":
      return <NoteIcon />;
    case "Notice":
      return <NoticeIcon />;
    case "Setting":
      return <SettingIcon />;
    case "Photo":
      return <PhotoIcon />;
    case "Temperature":
      return <TemperatureIcon />;
    default:
      return;
  }
};

const SidemenuContainer = styled.ul`
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    path {
      fill: ${({theme}) => theme.newTheme.border.thirdBd};
    }
    
    a {
      padding: 0.75rem 1rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.5rem;
      border-radius: 0.5rem;
      
      &:hover {
        background-color: ${colors.lightGray};
      }
      &.pending {
        color: red;
      }
      &.active {
        font-family: var(--font-nanumSquare-acB);
        color: ${({theme}) => theme.newTheme.default.primary};
        background-color: ${({theme}) => theme.newTheme.default.secondary};
        path {
          fill: ${({theme}) => theme.newTheme.default.accent};
        }
      }
    }
    &.drop-down {
      .drop-down-icon {
        margin-left: auto;
        &.open {
          transform: rotate(180deg);
        }
      }
      .sub-menu {
        padding-left: 3rem;
      }
    }
    &.none {
      display: none;
    }
`;

type subMenuType = {
  name: string;
  link: string;
  disabled?: boolean;
};

// 하위 메뉴가 있는 메뉴
export function DropDownMenu({ icon, linkTo, menuName, subMenuName, disabled = false, disabledByRole = false }:
  { icon: string; linkTo: string; menuName: string; subMenuName: subMenuType[]; disabled?: boolean; disabledByRole?: boolean; }) {
  
  const [isOpen, setIsOpen] = useState(false);

  function handleMenuClick( event: React.MouseEvent<HTMLAnchorElement, MouseEvent> ) {
    event.preventDefault();
    setIsOpen((prev) => !prev);
  }

  return (
    <SidemenuContainer className={`drop-down ${disabled ? "none" : ""}`}>
      <li>
        <NavLink to={linkTo}
          className={({ isActive, isPending }) => [isPending ? "pending" : "", isActive ? "active" : ""].join(" ")}
          onClick={(e) => handleMenuClick(e)}
        >
          {ReturnIconComponent(icon)}
          <span>{menuName}</span>
          <img className={`drop-down-icon ${isOpen ? "open" : ""}`} src="/image/icon/arrow_fill_down.svg" alt="dropdown" />
        </NavLink>
      </li>
      {isOpen &&
        subMenuName.map((sub, index) => (
          !sub.disabled &&
          <li key={index}>
            <NavLink to={sub.link} className={"sub-menu"}>
              {sub.name}
            </NavLink>
          </li>
        ))}
    </SidemenuContainer>
  );
}

// 하위 메뉴가 없는 메뉴
export function MenuOne({ icon, linkTo, menuName, disabled = false }: { icon: string; linkTo: string; menuName: string; disabled?: boolean; }) {
  return (
    <SidemenuContainer className={`menu-one ${disabled ? "none" : ""}`}>
      <li>
        <NavLink to={linkTo} end={icon === "board"}>
          {ReturnIconComponent(icon)}
          <span>{menuName}</span>
        </NavLink>
      </li>
    </SidemenuContainer>
  );
}

// sidemenu 접은 상태 - icon만 보이는 상태
export function SidemenuClose({ icon, linkTo, clickIcon, disabled = false }: { icon: string; linkTo: string; clickIcon: Function; disabled?: boolean;}) {
  // link 이동 막기
  function handleMenuClick(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
    event.preventDefault();
    clickIcon(false);
  }
  return (
    <SidemenuContainer className={`menu-one ${disabled ? "none" : ""}`}>
      <li>
        <NavLink to={linkTo} end={icon === "board"} onClick={(e) => handleMenuClick(e)}>
          {ReturnIconComponent(icon)}
        </NavLink>
      </li>
    </SidemenuContainer>
  );
}
